import { genComponentEl } from '@/utils/utils';
import Setting from './setting.vue';
import NuclideSetting from './nuclideSetting.vue';

export function rg05Setting(data) {
  genComponentEl(Setting, data);
}

export function rg05NuclideSetting(data) {
  genComponentEl(NuclideSetting, data);
}
